import React, { useEffect, useRef, useState } from 'react';
import '../../Dashboard.css';
import { store } from '../../Store/store';
import "bootstrap/dist/css/bootstrap.min.css";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, ResponsiveContainer } from 'recharts';
import { PieChart, Pie, Cell, Tooltip, Legend } from "recharts";
import { FaSearch, FaSpinner, FaArrowRight, FaTachometerAlt } from "react-icons/fa";
import * as DashboardService from '../../Services/Dashboard/DashboardService';
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { subDays, format } from "date-fns";
import { FaFileInvoiceDollar, FaCalendarAlt, FaMoneyBillWave, FaRegClock, FaLink, FaFilePdf } from "react-icons/fa";
import { LoadingMessage, formatVisitDate, currencySymbols, MHL_DOS_Links } from '../../Common/CommonVariables';

import TopTestDetailsConponentPieChart from "../Dashboard/Charts/TopTestDetailsConponentPieChart";
import CC_InvoiceListComponent from "../Dashboard/CC_Invoice/CC_InvoiceListComponent";
import TransactionCard from "../Dashboard/TransactionCard";
import TestAndRevenueComponent from "../Dashboard/TestAndRevenueComponent";
import VisitSummaryCard from "../Dashboard/VisitSummaryCard";
import Popover from '../../Common/Popper';
// import { } from "./";
import NotificationPopUpComponent from '../Notification/NotificationPopUpComponent';
import { useInvoiceTotalOutstanding, useRechargeRights } from '../../Common/CommonAccessFile';
import SalesAdminDashboardComponent from './SalesAdminDashboardComponent';
import CommonContainer from '../Container/CommonContainer';

const CustomXAxisTick = ({ x, y, payload }) => {
    const fullText = payload.value;

    const displayText = fullText.length > 10 ? `${fullText.slice(0, 10)}...` : fullText;
    return (
        <g transform={`translate(${x},${y})`}>
            <title>{fullText}</title>
            <text
                x={0}
                y={0}
                dy={16}
                textAnchor="end"
                fill="#8884d8"
                fontSize={10}
                fontWeight="bold"
                transform="rotate(-45)"
            >
                {displayText}
            </text>
        </g>
    );
};

const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
        const data = payload[0].payload;
        return (
            <div
                style={{
                    backgroundColor: '#fff',
                    border: '1px solid #ccc',
                    padding: '6px 10px 5px 10px',
                    borderRadius: '8px',
                    boxShadow: '0 0 10px rgba(0,0,0,0.1)',
                    fontSize: "11px",
                }}
            >
                <p style={{ margin: 0, padding: 0 }}><strong>Test Name:</strong> {data.TestName}</p>
                <p style={{ margin: 0 }}><strong>{data.tooltipLabel}:</strong> {payload[0].value}</p>
            </div>
        );
    }
    return null;
};

function DashboardComponent() {
    const accessToInvoiceTotalOutstanding = useInvoiceTotalOutstanding();
    const accessToRechargeRights = useRechargeRights();

    const userInfo = store.getState();
    const userData = userInfo?.userData || {};
    const userRole = userData?.Role_Name || "";
    const selectedOrg = useSelector((state) => state.selectedOrganization);
    const selectedSearchTestName = useRef();
    const [SearchLoading, setSearchLoading] = useState(false);
    const [barChartLoader, setBarChartLoader] = useState(true);
    const [pieChartLoader, setPieChartLoader] = useState(true);
    const [filteredTests, setFilteredTests] = useState([]);
    const [selectedTest, setSelectedTest] = useState(null);
    const inputRef = useRef();

    const [ChartData, setChartData] = useState([]);
    const [RateCardData, setRateCardData] = useState([]);
    const [BalanceData, setBalanceData] = useState({});
    const [CCInvoiceOutstandingData, setCCInvoiceOutstandingData] = useState({});

    const [viewMode, setViewMode] = useState('Revenue'); // Default is Revenue

    const paymentType = userInfo?.Partner_Account_Details?.MHL_Payment_Type__c;

    const navigate = useNavigate();
    const COLORS = ["#4caf50", "#2196f3", "#ff9800", "#f44336"];

    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [dateRangeOption, setdateRangeOption] = useState("Custom");

    const [testChartLoader, setTestChartLoader] = useState(true);
    const [topTestDetails, setTopTestDetails] = useState([]);

    const [triggerQuickSearch, setTriggerQuickSearch] = useState(false);

    const [RATransactionLoader, setRATransactionLoader] = useState(true);
    const [RATransactionCardData, setRATransactionCardData] = useState([]);

    const [ReportSerachReportGenrateData, setReportSerachReportGenrateData] = useState(0);
    const [ReportSerachTransactionsData, setReportSerachTransactionsData] = useState(0);
    const [ReportDelayedData, setReportDelayedData] = useState([]);
    const [DashboardPatientTransactionData, setDashboardPatientTransactionData] = useState(true);
    const [showReportModal, setShowReportModal] = useState(false);
    const [selectedFilter, setSelectedFilter] = useState(null);
    const [selectedRevenueMonth, setSelectedRevenueMonth] = useState(() =>
        new Date().toLocaleString('en-US', { month: 'short', year: 'numeric' }).toString());

    const [selectedNotification, setSelectedNotification] = useState([]);
    const [notificationModalStatus, setNotificationModalStatus] = useState(false)
    const [allNotifications, setAllNotifications] = useState([]);
    const [notificationLoader, setNotificationLoader] = useState(false);
    const [notificationAutoPopUpDet, setNotificationAutoPopUpDet] = useState(null);

    const handleQuickSearch = (days) => {
        setDashboardPatientTransactionData(true);
        setSelectedFilter(days);

        const today = new Date();
        let start = today;
        let end = today;
        let label = days;

        if (days === "Today") {
            // already set
        } else if (days === "2d") {
            start = subDays(today, 1);
        } else if (days === "Last 7 Days") {
            start = subDays(today, 6);
        } else if (days === "15d") {
            start = subDays(today, 14);
        } else if (days === "MTD") {
            start = new Date(today.getFullYear(), today.getMonth(), 1);
        }

        const formattedStart = format(start, 'yyyy-MM-dd');
        const formattedEnd = format(end, 'yyyy-MM-dd');

        setStartDate(formattedStart);
        setEndDate(formattedEnd);
        setdateRangeOption(label);

        const requestData = {
            StartDate: new Date(start.setHours(0, 0, 0, 0)).toISOString(),
            EndDate: new Date(end.setHours(23, 59, 59, 999)).toISOString(),
            Org_Id: "All"
        };
        DashboardService.DashboardPatientTransactionData(requestData).then(({ data }) => {
            if (data.IsSuccess) {
                ////debugger;
                setReportSerachReportGenrateData(data.Data.ReportSerachReportGenrateData);
                setReportSerachTransactionsData(data.Data.ReportSerachTransactionsData);
                setReportDelayedData(data.Data.ReportDelayedData);
            } else {
                setReportSerachReportGenrateData(0);
                setReportSerachTransactionsData(0);
                setReportDelayedData([]);
            }
        }).catch(() => toast.error("Something went wrong."))
            .finally(() => setDashboardPatientTransactionData(false));
    };

    // const handlePatientVisitSearch = () => {
    //     navigate("/patientvisit", {
    //         state: {
    //             startDate,
    //             endDate,
    //             dateRangeOption
    //         }
    //     });
    // };

    // const handleQuickSearch = (days) => {
    //     setDashboardPatientTransactionData(true);
    //     const today = new Date();
    //     let start, end;
    //     let label = "Custom";

    //     if (days === "Today") {
    //         start = today;
    //         end = today;
    //         label = "Today";
    //     } else if (days === "Yesterday") {
    //         const yesterday = subDays(today, 1);
    //         start = yesterday;
    //         end = yesterday;
    //         label = "Yesterday";
    //     } else if (typeof days === "number") {
    //         start = subDays(today, days - 1); // e.g., 3-day means today and past 2 days
    //         end = today;
    //         label = "Custom";
    //     } else {
    //         // Fallback
    //         start = today;
    //         end = today;
    //     }

    //     const formattedStart = format(start, 'yyyy-MM-dd');
    //     const formattedEnd = format(end, 'yyyy-MM-dd');

    //     setStartDate(formattedStart);
    //     setEndDate(formattedEnd);
    //     setdateRangeOption(label);
    //     // setTriggerQuickSearch(true);
    //     ////debugger;
    //     const requestData = {
    //         // StartDate: formatDateToUTC(startDate),
    //         StartDate: start
    //             ? new Date(new Date(start).setHours(0, 0, 0, 0)).toISOString()
    //             : null,
    //         EndDate: end
    //             ? new Date(new Date(end).setHours(23, 59, 59, 999)).toISOString()
    //             : null,
    //         Org_Id: "All"
    //     };
    //     DashboardService.DashboardPatientTransactionData(requestData).then(({ data }) => {
    //         ////debugger;
    //         if (data.IsSuccess) {
    //             setReportSerachReportGenrateData(data.Data.ReportSerachReportGenrateData)
    //             setReportSerachTransactionsData(data.Data.ReportSerachTransactionsData)
    //         }
    //         else {
    //             setReportSerachTransactionsData(0)
    //             setReportSerachTransactionsData(0)

    //         }
    //     })
    //         .catch(() => toast.error("Something went wrong."))
    //         .finally(() => {
    //             setDashboardPatientTransactionData(false);
    //         });
    // };


    // useEffect(() => {
    //     if (triggerQuickSearch && startDate && endDate) {
    //         handlePatientVisitSearch();
    //         setTriggerQuickSearch(false); // reset trigger
    //     }
    // }, [startDate, endDate, triggerQuickSearch]);


    const handlePatientVisitSearch = () => {
        const allowedOptions = ["Last 7 Days", "MTD", "Today"];
        const selectedOption = allowedOptions.includes(dateRangeOption) ? dateRangeOption : "Custom";

        navigate("/patientvisit", {
            state: {
                startDate,
                endDate,
                dateRangeOption: selectedOption
            }
        });
    };

    const fetchNotificationDet_ByPartnerCode = () => {
        setNotificationLoader(true);

        DashboardService.GetNotificationDet_ByPartnerCode(userInfo.userData?.Partner_Code)
            .then(({ data }) => {
                if (data.IsSuccess) {
                    ////debugger;
                    setAllNotifications(data.Data)
                    const myFirstPopup = data.Data.find(
                        (notification) => notification.Is_Popup_Notification === true
                    );
                    setNotificationAutoPopUpDet(myFirstPopup);
                }
                else {
                    setAllNotifications([])
                }
            })
            .catch(() => toast.error("Something went wrong."))
            .finally(() => {
                setNotificationLoader(false);
            });
    }

    const fetchPartnerDashboardDetails = () => {
        setBarChartLoader(true);
        setChartData([])
        DashboardService.GetDashboardDetails()
            .then(({ data }) => {
                if (data.IsSuccess) {
                    const formatted = data.Data.TestDataGraph.map(item => ({
                        ...item,
                        tooltipLabel: viewMode === 'Count' ? 'Count' : 'Revenue'
                    }));
                    setChartData(formatted);
                    setBarChartLoader(false);
                    setBalanceData(data.Data.BalanceData);

                }
            })
            .catch(() => toast.error("Something went wrong."))
            .finally(() => {
                setBarChartLoader(false);
            });
    };

    const GetDashboard_TopTestDetails = () => {
        ////debugger;
        setTestChartLoader(true);
        setTopTestDetails([])

        DashboardService.GetDashboard_TopTestDetails(selectedRevenueMonth)
            .then(({ data }) => {
                ////debugger;
                if (data.IsSuccess) {
                    //console.log("Top Test Details Data:", data.Data);
                    setTopTestDetails(data.Data);
                }
                else {
                    setTopTestDetails([]);
                }
            })
            .catch(() => toast.error("Something went wrong."))
            .finally(() => {
                setTestChartLoader(false);
            });
    };


    const GetDashboard_BarChartTestDetails = () => {
        setBarChartLoader(true);
        setChartData([])
        DashboardService.GetDashboard_BarChartTestDetails()
            .then(({ data }) => {
                if (data.IsSuccess) {
                    const formatted = data.Data.map(item => ({
                        ...item,
                        tooltipLabel: viewMode === 'Count' ? 'Count' : 'Revenue'
                    }));
                    setChartData(formatted);
                    setBarChartLoader(false);
                }
                else {
                    setChartData([])
                }
            })
            .catch(() => toast.error("Something went wrong."))
            .finally(() => {
                setBarChartLoader(false);
            });
    };

    const GetRA_TransactionCard = () => {
        setRATransactionLoader(true);
        setRATransactionCardData([])
        DashboardService.GetRA_TransactionCard()
            .then(({ data }) => {
                ////debugger;
                if (data.IsSuccess) {
                    setRATransactionCardData(data.Data);
                    setRATransactionLoader(false);
                }
                else {
                    setRATransactionLoader(false);
                    setRATransactionCardData([])
                }
            })
            .catch(() => toast.error("Something went wrong."))
            .finally(() => {
                setRATransactionLoader(false);
            });
    };

    const GetDashboard_TotalOutStandingPreviousMonth = () => {
        setPieChartLoader(true);
        setCCInvoiceOutstandingData([])
        DashboardService.GetDashboard_TotalOutStandingPreviousMonth()
            .then(({ data }) => {
                if (data.IsSuccess) {
                    setPieChartLoader(false);
                    setCCInvoiceOutstandingData(data.Data);
                    const invoices = data?.Data?.invDetails?.slice(0, 3) || [];
                    const balance = data?.Data?.ClientGLBalance || 0;
                    const outstanding = data?.Data?.ClientOutstandingAmt || 0;

                    const currentInvoiceDate = (() => {
                        const rawDate = invoices?.[0]?.invoiceDate;
                        if (!rawDate) return "N/A";
                        const [day, month, year] = rawDate.split("/");
                        const parsedDate = new Date(`${year}-${month}-${day}`);
                        const shortMonth = parsedDate.toLocaleString("en-US", { month: "short" });
                        return `${shortMonth}/${year}`;
                    })();

                }
                else {
                    setCCInvoiceOutstandingData({})
                }
            })
            .catch(() => toast.error("Something went wrong."))
            .finally(() => { setPieChartLoader(false); });
    };

    const GetDashboard_RAPieChartAccountBalanceDetails = () => {
        setPieChartLoader(true);
        setBalanceData([])
        DashboardService.GetDashboard_RAPieChartAccountBalanceDetails()
            .then(({ data }) => {
                if (data.IsSuccess) {
                    setPieChartLoader(false);
                    setBalanceData(data.Data);
                }
                else {
                    setBalanceData([]);
                }
            })
            .catch(() => toast.error("Something went wrong."))
            .finally(() => {
                setBarChartLoader(false);
            });
    };

    useEffect(() => {
        // ////debugger;
        if (userInfo.Partner_Account_Details && userInfo.Partner_Account_Details.MHL_Status__c && paymentType == "Rolling Advance") {
            // fetchPartnerDashboardDetails();
            GetDashboard_TopTestDetails();
            GetDashboard_BarChartTestDetails();
            GetRA_TransactionCard();
            handleQuickSearch('Today');
            fetchNotificationDet_ByPartnerCode();
            // GetDashboard_RAPieChartAccountBalanceDetails();

        }
        if (userInfo.Partner_Account_Details && userInfo.Partner_Account_Details.MHL_Status__c && (paymentType == "Credit" || paymentType == "Cash")) {
            GetDashboard_TopTestDetails();
            GetDashboard_TotalOutStandingPreviousMonth();
            GetDashboard_BarChartTestDetails();
            handleQuickSearch('Today');
            fetchNotificationDet_ByPartnerCode();
        }
    }, []);

    useEffect(() => {
        // ////debugger;
        // if (userInfo.Partner_Account_Details && userInfo.Partner_Account_Details.MHL_Status__c && paymentType == "Rolling Advance") {
        //     // fetchPartnerDashboardDetails();
        //     GetDashboard_TopTestDetails();
        // }
        // if (userInfo.Partner_Account_Details && userInfo.Partner_Account_Details.MHL_Status__c && paymentType == "Credit") {
        //     GetDashboard_TopTestDetails();
        // }
        if (userInfo.Partner_Account_Details && userInfo.Partner_Account_Details.MHL_Status__c && (paymentType == "Rolling Advance" || paymentType == "Credit" || paymentType == "Cash")) {
            GetDashboard_TopTestDetails();
        }
    }, [selectedRevenueMonth]);

    useEffect(() => {
        //debugger;
        const storedValue = localStorage.getItem('notificationModalStatus');
        const parsedStoredValue = storedValue ? JSON.parse(storedValue) : null;

        if (parsedStoredValue !== false && notificationAutoPopUpDet) {
            setSelectedNotification(notificationAutoPopUpDet);
            setNotificationModalStatus(true);
            localStorage.setItem('notificationModalStatus', JSON.stringify(true));
        } else if (parsedStoredValue !== null) {
            setNotificationModalStatus(parsedStoredValue);
        }
    }, [notificationAutoPopUpDet]);

    useEffect(() => {
        const updated = ChartData.map(item => ({
            ...item,
            tooltipLabel: viewMode === 'Count' ? 'Count' : 'Revenue'
        }));
        setChartData(updated);
    }, [viewMode]);

    const handleBarClick = (data, index) => {
        //console.log("Bar clicked:", data);
        // Use data for detailed view or routing if needed
    };

    const fetchRateCard = () => {
        setRateCardData([])
        setFilteredTests([])
        setSelectedTest(null)
        setSearchLoading(true);
        if (selectedSearchTestName.current.value == null || selectedSearchTestName.current.value == "") {
            toast.error("Please enter search data.")
            setSearchLoading(false);
            return;
        }

        const requestData = {
            clientCode: userInfo?.Partner_Account_Details?.MHL_Client_Code__c,
            testSearch: selectedSearchTestName.current.value,
            orgId: selectedOrg.MHL_Org_Id__c
        };

        DashboardService.FetchPriceFromRNI(requestData).then(({ data }) => {
            if (data.IsSuccess) {
                ////debugger;
                setRateCardData(data.Data)
            }
            else {
                setRateCardData([])
                setFilteredTests([])
                setSelectedTest(null)
            }
        })
            .catch(() => toast.error("Something went wrong."))
            .finally(() => {
                setSearchLoading(false);
            });
    };

    const handleModalClose = () => {
        //debugger;
        setNotificationModalStatus(false);
        localStorage.setItem('notificationModalStatus', JSON.stringify(false));
    }

    const handleNotificationClick = (rec) => {
        setSelectedNotification(rec);
        setNotificationModalStatus(true);
    }

    return (
        // <div className="container-fluid p-2" style={{ backgroundColor: "#f5f5f5", minHeight: "125vh" }}>
        <div className="container-fluid" style={{ backgroundColor: "#f5f5f5", minHeight: "125vh" }}>
            {userInfo.Partner_Account_Details && userInfo.Partner_Account_Details.MHL_Status__c ? (
                <>
                    {/* Header */}
                    {/* <div className="rounded p-3 mb-3" style={{ backgroundColor: "#e4f4e0" }}>
                        <div className="d-flex justify-content-between align-items-center custom-smheader">
                            <div>
                                <small>WELCOME TO METROPOLIS</small>
                                <h4 className="fw-bold">Power your Revenue Opportunity</h4>
                            </div>
                            <div className="stats-card-container mt-2">
                                <div className="stats-card-enhanced">
                                    <div className="d-flex align-items-center justify-content-center custom-header-content">
                                        <div className="stats-item-enhanced flex-fill">
                                            <div className="stats-growth-indicator"></div>
                                            <div className="d-flex align-items-center">
                                                <div className="stats-icon-enhanced ">
                                                    <i className="fas fa-users"></i>
                                                </div>
                                                <div className="flex-grow-1">
                                                    <div className="stats-number-enhanced">65</div>
                                                    <p className="stats-label-enhanced">Customers/Month</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="stats-divider-enhanced"></div>

                                        <div className="stats-item-enhanced flex-fill">
                                            <div className="stats-growth-indicator"></div>
                                            <div className="d-flex align-items-center">
                                                <div className="stats-icon-enhanced stats-revenue-icon">
                                                    <i className="fas fa-chart-line"></i>
                                                </div>
                                                <div className="flex-grow-1">
                                                    <div className="stats-number-enhanced">{currencySymbols[userInfo?.Partner_Account_Details?.CurrencyIsoCode]}70,000</div>
                                                    <p className="stats-label-enhanced">Potential Revenue</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> */}

                    <div className="row g-3">
                        <VisitSummaryCard
                            selectedFilter={selectedFilter}
                            handleQuickSearch={handleQuickSearch}
                            ReportSerachTransactionsData={ReportSerachTransactionsData}
                            ReportSerachReportGenrateData={ReportSerachReportGenrateData}
                            ReportDelayedData={ReportDelayedData}
                            showReportModal={showReportModal}
                            setShowReportModal={setShowReportModal}
                            formatVisitDate={formatVisitDate}
                            onViewAllVisits={handlePatientVisitSearch}
                            loader={DashboardPatientTransactionData}
                            startDate={startDate}
                            endDate={endDate}
                            dateRangeOption={dateRangeOption}
                        />

                        {/* <div className="col-md-6 col-lg-4">
                            <div className="bg-white rounded p-2 shadow-sm h-100">
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <h5 className="mb-0">Visit's Summary</h5>
                                    <div className="btn-group">
                                        <button className={`btn btn-outline-success btn-sm ${selectedFilter === 'Today' ? 'active' : ''}`} style={{ border: 'none' }} onClick={() => handleQuickSearch('Today')}>Today</button>
                                        <button className={`btn btn-outline-success btn-sm ${selectedFilter === '2d' ? 'active' : ''}`} style={{ border: 'none' }} onClick={() => handleQuickSearch('2d')}>2d</button>
                                        <button className={`btn btn-outline-success btn-sm ${selectedFilter === '7d' ? 'active' : ''}`} style={{ border: 'none' }} onClick={() => handleQuickSearch('7d')}>7d</button>
                                        <button className={`btn btn-outline-success btn-sm ${selectedFilter === '15d' ? 'active' : ''}`} style={{ border: 'none' }} onClick={() => handleQuickSearch('15d')}>15d</button>
                                        <button className={`btn btn-outline-success btn-sm ${selectedFilter === 'MTD' ? 'active' : ''}`} style={{ border: 'none' }} onClick={() => handleQuickSearch('MTD')}>MTD</button>
                                    </div>

                                </div>
                                <>

                                    <div className="row row-cols-2 g-2 justify-content-center  mb-2">

                                        <div className="col">

                                            <div className="text-center border rounded p-2 d-flex flex-column align-items-center justify-content-center" style={{ minHeight: '85px' }}>
                                                <div className="d-flex align-items-center justify-content-center mb-1 fs-6 fw-semibold">
                                                    {ReportSerachTransactionsData || 0}
                                                </div>
                                                <small className="text-dark">Patient Visits</small>
                                            </div>
                                        </div>

                                       
                                        <div className="col">
                                            <div className="text-center border rounded p-2 d-flex flex-column align-items-center justify-content-center" style={{ minHeight: '85px' }}>
                                                <div className="d-flex align-items-center justify-content-center mb-1 fs-6 fw-semibold">
                                                    {ReportSerachReportGenrateData || 0}
                                                </div>
                                                <small className="text-dark">Report Generated</small>
                                            </div>
                                        </div>
                                    
                                    </div>
                                    <div className="row row-cols-1 g-2 justify-content-center mb-2">
                                        <div className="col">
                                            <div
                                                className="text-center border rounded d-flex flex-column align-items-center justify-content-center position-relative"
                                                style={{ minHeight: '85px' }}
                                            >
                                                <div className="d-flex align-items-center justify-content-center mb-1 fs-6 fw-semibold">
                                                    <small className="text-dark">Report Delayed: </small>&nbsp;
                                                    {ReportDelayedData?.length || 0}
                                                </div>
                                                <i
                                                    className="fa fa-eye position-absolute"
                                                    style={{
                                                        top: '8px',
                                                        right: '10px',
                                                        cursor: 'pointer',
                                                        fontSize: '1rem',
                                                        color: '#0d6efd',
                                                    }}
                                                    title="View Details"
                                                    onClick={() => setShowReportModal(true)}
                                                ></i>
                                            </div>
                                        </div>
                                    </div>
                                </>

                                <div className="text-end">

                                    <a href="/transactions" className="text-decoration-none fw-bold small" style={{ color: "#00984A", fontSize: "12px" }}>
                                        View All Transactions <FaArrowRight className="ms-1" style={{ fontSize: "11px" }} />
                                    </a>

                                </div>
                            </div>
                        </div>
                        {showReportModal && (
                            <div className="modal-backdrop">
                                <div className="modal fade show d-block" tabIndex="-1" role="dialog">
                                    <div className="modal-dialog modal-xl" role="document">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h5 className="modal-title">Report Delayed Records</h5>
                                                <button
                                                    type="button"
                                                    className="btn-close"
                                                    onClick={() => setShowReportModal(false)}
                                                ></button>
                                            </div>
                                            <div className="modal-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                                                <div className="table-responsive" >
                                                    <table className="table table-bordered custom-table" >
                                                        <thead>
                                                            <tr>
                                                                <th >Patient Name</th>
                                                                <th >VID</th>
                                                                <th >VID Date</th>
                                                                <th >Test Name</th>
                                                                <th >TAT</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {ReportDelayedData?.map((rec, idx) => (
                                                                <tr key={idx}>
                                                                    <td>{rec.MHL_Patient_Name}</td>
                                                                    <td>{rec.Name}</td>
                                                                    <td>{formatVisitDate(rec.MHL_Visit_Date__c)}</td>
                                                                    <td>
                                                                        {rec.MHL_Test_Details_List.length === 1 && (
                                                                            <>
                                                                                {rec.MHL_Test_Details_List[0].MHL_TestName__c.length > 30 ? (
                                                                                    <Popover
                                                                                        content={
                                                                                            <span>{rec.MHL_Test_Details_List[0].MHL_TestName__c}</span>
                                                                                        }
                                                                                    >
                                                                                        <span style={{ cursor: 'pointer' }}>
                                                                                            {rec.MHL_Test_Details_List[0].MHL_TestName__c.substring(0, 30)}...
                                                                                        </span>
                                                                                    </Popover>
                                                                                ) : (
                                                                                    rec.MHL_Test_Details_List[0].MHL_TestName__c
                                                                                )}
                                                                            </>
                                                                        )}

                                                                        {rec.MHL_Test_Details_List?.length > 1 && (
                                                                            <Popover
                                                                                content={
                                                                                    <ul
                                                                                        className="list-unstyled"
                                                                                        style={{ textAlign: 'left', paddingLeft: '1rem', margin: 0 }}
                                                                                    >
                                                                                        {rec.MHL_Test_Details_List.map((test, index) => (
                                                                                            <li key={index}>{test.MHL_TestName__c}</li>
                                                                                        ))}
                                                                                    </ul>
                                                                                }
                                                                            >
                                                                                <span style={{ marginLeft: '5px', cursor: 'pointer' }}>
                                                                                    {rec.MHL_Test_Details_List[0].MHL_TestName__c.length > 30
                                                                                        ? `${rec.MHL_Test_Details_List[0].MHL_TestName__c.substring(0, 30)}...`
                                                                                        : rec.MHL_Test_Details_List[0].MHL_TestName__c}
                                                                                    {` (+${rec.MHL_Test_Details_List.length - 1})`}
                                                                                </span>
                                                                            </Popover>
                                                                        )}
                                                                    </td>
                                                                    <td>{rec.MHL_Test_TAT_Date || '-'}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                            <div className="modal-footer">
                                                <button
                                                    type="button"
                                                    className="btn btn-danger"
                                                    onClick={() => setShowReportModal(false)}
                                                >
                                                    Close
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )} */}
                        {/* <div className="col-md-6 col-lg-4">
                            <div className="bg-white rounded p-2 shadow-sm h-100">
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <h5 className="mb-0">Report Search</h5>
                                    <div className="btn-group">
                                        <button className="btn report-search-btn btn-sm" style={{ border: 'none' }} onClick={() => handleQuickSearch('Today')}>Today</button>
                                        <button className="btn report-search-btn btn-sm" style={{ border: 'none' }} onClick={() => handleQuickSearch(2)}>2d</button>
                                        <button className="btn report-search-btn btn-sm" style={{ border: 'none' }} onClick={() => handleQuickSearch(7)}>7d</button>
                                        <button className="btn report-search-btn btn-sm" style={{ border: 'none' }} onClick={() => handleQuickSearch(15)}>15d</button>
                                    </div>

                                </div>

                                <label className="form-label">Start Date</label>
                                <input
                                    type="date"
                                    className="form-control mb-2"
                                    value={startDate}
                                    onChange={(e) => setStartDate(e.target.value)}
                                />
                                <label className="form-label">End Date</label>
                                <input
                                    type="date"
                                    className="form-control mb-2"
                                    value={endDate}
                                    onChange={(e) => setEndDate(e.target.value)}
                                />
                                <div className="d-flex justify-content-center">
                                    <button className="btn custom-sumbitbtn" onClick={handlePatientVisitSearch}>
                                        Search
                                    </button>
                                </div>
                            </div>
                        </div> */}

                        <div className="col-md-6 col-lg-4">
                            <div className="bg-white rounded p-3 dashboard-card dashboard-card-enhanced shadow-sm h-100">

                                <h5>Rate Card&nbsp;</h5>
                                <div className="search-box-dashboard position-relative w-100 mb-2">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Search by Test Name, Code"
                                        ref={selectedSearchTestName}
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                                fetchRateCard();
                                            }
                                        }}
                                        onChange={(e) => {
                                            if (!e.target.value.trim()) {
                                                setRateCardData([]);
                                            }
                                        }}
                                        style={{ paddingRight: "45px" }}
                                    />
                                    <button
                                        className="btn custom-sumbitbtn position-absolute d-flex justify-content-center align-items-center"
                                        title="Click to get RNI Rate"
                                        style={{
                                            padding: "5px",
                                            right: "0px",
                                            height: "35px",
                                            width: "100px",
                                            top: "50%",
                                            fontSize: "13px",
                                            borderTopLeftRadius: "0",
                                            borderBottomLeftRadius: "0",
                                            transform: "translateY(-50%)"
                                        }}
                                        onClick={fetchRateCard}
                                    >
                                        {SearchLoading ? <FaSpinner className="fa-spin" /> : <b>Get RNI Rate</b>}
                                    </button>
                                </div>

                                {RateCardData.length > 0 ? (
                                    <div
                                        className="list-group border mb-2 pt-1"
                                        style={{ maxHeight: "180px", overflowY: "auto", fontSize: "12px", border: '1px' }}
                                    >
                                        {RateCardData.map((test, idx) => (
                                            <button
                                                key={idx}
                                                className={`list-group-item list-group-item-action 
                                                ${selectedTest?.testCode === test.testCode ? "fw-bold" : ""}`}
                                                style={selectedTest?.testCode === test.testCode ? { backgroundColor: "rgb(180, 227, 168)" } : {}}
                                                onClick={() => setSelectedTest(test)}
                                            >

                                                <div className="d-flex justify-content-between align-items-start mb-1 pr-2">
                                                    {/* Left Section */}
                                                    <div className="flex-grow-1 pe-2">
                                                        <div className="fw-semibold">
                                                            {test.testName} <span className="text-muted small">({test.testCode})</span>
                                                        </div>
                                                    </div>

                                                    <div className="col-2 text-end">
                                                        <span className="rounded-pill px-3 py-2">{test.testType}</span>
                                                    </div>
                                                </div>
                                                <div className="text-muted small mt-1">
                                                    <span className="me-5">MRP: {currencySymbols[userInfo?.Partner_Account_Details?.CurrencyIsoCode]}{test.mrp}</span>
                                                    {test.DiscountCategory?.trim() && <span className="me-6">Category: {test.DiscountCategory}</span>}
                                                    <span style={{ float: "right" }}>Net: {currencySymbols[userInfo?.Partner_Account_Details?.CurrencyIsoCode]}<span className='fw-bold'>{test.amount}</span></span>
                                                </div>

                                            </button>
                                        ))}
                                    </div>
                                ) : (selectedSearchTestName.current?.value) ? (
                                    <div className="alert alert-warning p-2" style={{ fontSize: "12px" }}>
                                        {SearchLoading ? <LoadingMessage /> : "No test records found."}
                                    </div>
                                ) : <></>}
                            </div>
                        </div>


                        {/* My Balance */}
                        <div className="col-md-6 col-lg-4">
                            {
                                (paymentType === "Credit" || paymentType === "Cash") ? (
                                    <div className="bg-white rounded p-3 dashboard-card dashboard-card-enhanced shadow-sm h-100">
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                            <h5 className="mb-0">Total O/S{CCInvoiceOutstandingData?.ClientGLBalance && accessToInvoiceTotalOutstanding && (<small>: {currencySymbols[userInfo?.Partner_Account_Details?.CurrencyIsoCode]}{CCInvoiceOutstandingData.ClientGLBalance}</small>)}</h5>
                                        </div>

                                        {pieChartLoader ? (
                                            <div className="centered-message-loader">
                                                <FaSpinner
                                                    style={{ width: "50px", height: "50px", color: "green" }}
                                                    className="fa-spin text-dark-500"
                                                />
                                            </div>
                                        ) : (
                                            <>
                                                {(CCInvoiceOutstandingData?.ClientGLBalance && CCInvoiceOutstandingData?.ClientGLBalance) ? (
                                                    <CC_InvoiceListComponent data={CCInvoiceOutstandingData} />
                                                ) : (
                                                    <div className="alert alert-warning p-2" style={{ fontSize: '12px' }}>
                                                        No invoice found.
                                                    </div>
                                                )}
                                            </>
                                        )}
                                    </div>

                                ) : (

                                    <div className="bg-white position-relative rounded p-3 dashboard-card dashboard-card-enhanced shadow-sm h-100">
                                        <div className="d-flex flex-column flex-sm-row justify-content-between align-items-xl-center mb-3">
                                            <h5 className="mb-0">
                                                Transactions
                                                <small className="text-dark fw-bold ml-1" style={{ fontSize: '0.7rem' }}>
                                                    ({new Date().toLocaleString('en-US', { month: 'short' }) + '-' + String(new Date().getFullYear()).slice(-2)})
                                                </small>
                                            </h5>
                                            {accessToRechargeRights &&
                                                <a
                                                    href="https://freepay.co/FreepayNG"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="btn custom-sumbitbtn mt-3 mt-sm-0 align-self-center btn-sm px-3"
                                                >
                                                    Recharge
                                                </a>
                                            }
                                        </div>
                                        {RATransactionLoader ? (
                                            <div className='centered-message-loader'>
                                                <FaSpinner
                                                    style={{ width: "50px", height: "50px", color: "green" }}
                                                    className="fa-spin text-dark-500"
                                                />
                                            </div>
                                        ) : (
                                            <>
                                                {RATransactionCardData ? (
                                                    <TransactionCard data={RATransactionCardData} />
                                                ) : (
                                                    // <div className='centered-message'>
                                                    //     No transaction found
                                                    // </div>
                                                    <div className="alert alert-warning p-2" style={{ fontSize: '12px' }}>
                                                        No records found.
                                                    </div>
                                                )}
                                            </>
                                        )}

                                    </div>
                                )
                            }
                        </div>
                    </div>

                    <div className="row g-3 pt-3">
                        <div className="col-md-6 col-lg-4">
                            <div className="bg-white rounded p-3 dashboard-card dashboard-card-enhanced shadow-sm h-100">
                                <div className="d-flex flex-column flex-xl-row justify-content-between align-items-xl-center mb-2">
                                    <h5 className='mb-0'>Important Updates</h5>
                                </div>

                                {notificationLoader ? (
                                    <div className='centered-message-loader'>
                                        <FaSpinner style={{ width: "50px", height: "50px", color: "green" }} className="fa-spin text-dark-500" />
                                    </div>
                                ) : (
                                    <div style={{height: '200px'}}>
                                        {allNotifications?.length > 0 ? (
                                            <div style={{
                                                maxHeight: '280px',
                                                overflowY: 'auto',
                                                paddingRight: '5px' // Optional: adds space for scrollbar
                                            }}>
                                                {allNotifications.map((notification) => (
                                                    <div key={notification.Id} className="d-flex flex-column">
                                                        <ul style={{ marginBottom: '6px', marginTop: '8px', paddingLeft: '10px' }}>
                                                            <li className='custom-update notification-title-truncate'
                                                                onClick={() => handleNotificationClick(notification)}
                                                                style={{ cursor: 'pointer', fontSize: 'small' }}
                                                            >
                                                                {notification.Title}
                                                            </li>
                                                        </ul>
                                                    </div>
                                                ))}
                                            </div>
                                        ) : (
                                            <div className="alert alert-warning p-2" style={{ fontSize: '12px' }}>
                                                Currently no updates found.
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                        {/* //COunt&Revenue */}
                        {/* <div className="col-md-6 col-lg-4">
                            <div className="bg-white rounded p-3 dashboard-card dashboard-card-enhanced shadow-sm h-100">
                                <div className="d-flex flex-column flex-xl-row justify-content-between align-items-xl-center mb-2">
                                    <h5 className='mb-0'>Top 10 Tests</h5>
                                    <div className="d-flex my-3 my-xl-0 align-self-center bg-light rounded-pill p-1" style={{ width: "fit-content" }}>
                                        <button
                                            className={`btn btn-sm rounded-pill border-0 px-4 ${viewMode === 'Count' ? 'custom-sumbitbtn text-white' : 'bg-transparent text-dark'}`}
                                            onClick={() => setViewMode('Count')}
                                        >
                                            Count
                                        </button>
                                        <button
                                            className={`btn btn-sm rounded-pill border-0 px-4 ${viewMode === 'Revenue' ? 'custom-sumbitbtn text-white' : 'bg-transparent text-dark'}`}
                                            onClick={() => setViewMode('Revenue')}
                                        >
                                            Revenue
                                        </button>
                                    </div>
                                </div>

                                {barChartLoader ? (
                                    <div className='centered-message-loader'>
                                        <FaSpinner style={{ width: "50px", height: "50px", color: "green" }} className="fa-spin text-dark-500" />
                                    </div>
                                ) : (

                                    <>
                                        {ChartData && ChartData.length > 0 ? (
                                            <ResponsiveContainer width="100%" height={300}>
                                                <BarChart
                                                    data={ChartData}
                                                    margin={{ top: 10, right: 10, left: 10, bottom: 60 }}
                                                    onClick={(e) => {
                                                        if (e && e.activePayload && e.activePayload[0]) {
                                                            handleBarClick(e.activePayload[0].payload, e.activeTooltipIndex);
                                                        }
                                                    }}
                                                >
                                                    <CartesianGrid stroke="#e0e0e0" strokeDasharray="3 3" />
                                                    <XAxis
                                                        dataKey="TestName"
                                                        tick={<CustomXAxisTick />}
                                                        axisLine={{ stroke: '#ccc' }}
                                                        tickLine={false}
                                                        interval={0}
                                                        label={{
                                                            value: 'Test Name',
                                                            position: 'insideBottom',
                                                            offset: -45,
                                                            fontSize: 12,
                                                            fill: '#555',
                                                            fontWeight: 'bold',
                                                        }}
                                                    />
                                                    <YAxis
                                                        tick={{ fontSize: 10, fill: '#8884d8', fontWeight: 'bold' }}
                                                        axisLine={{ stroke: '#ccc' }}
                                                        tickLine={false}
                                                        label={{
                                                            value: viewMode === 'Count' ? 'Test Count' : 'Revenue',
                                                            angle: -90,
                                                            position: 'insideLeft',
                                                            offset: 0,
                                                            fontSize: 12,
                                                            fill: '#555',
                                                            fontWeight: 'bold',
                                                        }}
                                                    />
                                                    <Tooltip content={<CustomTooltip />} cursor={{ fill: 'rgba(0, 0, 0, 0.1)' }} />
                                                    <Bar
                                                        dataKey={viewMode === 'Count' ? 'Count' : 'Test_NetAmount'}
                                                        fill="#4caf50"
                                                        barSize={15}
                                                        radius={[10, 10, 0, 0]}
                                                    />
                                                </BarChart>
                                            </ResponsiveContainer>
                                        ) : (
                                           
                                            <div className="alert alert-warning p-2" style={{ fontSize: '12px' }}>
                                                No records found.
                                            </div>
                                        )}
                                    </>

                                )}

                            </div>
                        </div> */}

                        <div className="col-md-6 col-lg-4">
                            <div className="bg-white rounded p-3 dashboard-card dashboard-card-enhanced shadow-sm h-100">
                                <h5>Service Console</h5>
                                <div className="d-flex flex-column gap-2 mt-3">
                                    {/* <a
                                        title='Registration Link'
                                        href="https://rni.metropolisindia.com/login.html"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="btn serviceconsloebtn-hover d-flex justify-content-between align-items-center"
                                    >
                                        <span>RNI - Registration Link</span>
                                        <span>&rarr;</span>
                                    </a> */}

                                    <a
                                        title='Metropolis DOS'
                                        // href="https://dos.metropolisindia.com/"
                                        href={MHL_DOS_Links[userInfo?.Partner_Account_Details?.CurrencyIsoCode]}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="btn serviceconsloebtn-hover d-flex justify-content-between align-items-center"
                                    >
                                        <span>Metropolis DOS</span>
                                        <span> &rarr;</span>
                                    </a>
                                    <a
                                        href="/partnercase"
                                        className="btn serviceconsloebtn-hover d-flex justify-content-between align-items-center"
                                    >
                                        <span>Partner Case Details</span>
                                        <span> &rarr;</span>
                                    </a>
                                    {/* <a title='in progress'
                                        href="/homevisit"
                                        className="btn serviceconsloebtn-hover d-flex justify-content-between align-items-center"
                                    >
                                        <span>Home Visits</span>
                                        <span> &rarr;</span>
                                    </a> */}
                                </div>
                            </div>
                        </div>

                        <TestAndRevenueComponent
                            testChartLoader={testChartLoader}
                            topTestDetails={topTestDetails}
                            setSelectedRevenueMonth={setSelectedRevenueMonth}
                        />
                        {/* <div className="col-md-6 col-lg-4" style={{ position: 'relative' }}>
                            <div className="bg-white rounded p-2 shadow-sm h-100 mb-4">

                                <div className="d-flex justify-content-between align-items-center mb-2">
                                    <h5 className="mb-0">Top Tests & Revenue</h5>
                                    <span
                                        className="badge custom-sumbitbtn text-white px-3 py-2"
                                        style={{ fontSize: '12px' }}
                                    >
                                        {new Date().toLocaleString('en-US', { month: 'short', year: 'numeric' }).replace(',', '/')}
                                    </span>

                                </div>


                                {testChartLoader ? (
                                    <div className='centered-message-loader'>
                                        <FaSpinner
                                            style={{ width: "50px", height: "50px", color: "green" }}
                                            className="fa-spin"
                                        />
                                    </div>


                                ) : topTestDetails.length > 0 ? (
                                    <div className="card border mb-2" style={{ fontSize: '12px' }}>
                                        <div className="card-header fw-bold d-flex justify-content-between align-items-center p-1">
                                            <span></span>
                                            <select
                                                value={sortBy}
                                                onChange={(e) => setSortBy(e.target.value)}
                                                className="form-select form-select-sm w-auto"
                                                style={{ fontSize: '10px' }}
                                            >
                                                <option value="Test_NetAmount">Sort by Revenue</option>
                                                <option value="Count">Sort by Count</option>
                                            </select>
                                        </div>

                                        <div
                                            className="px-2"
                                            style={{
                                                maxHeight: topTestDetails.length > 2 ? '250px' : 'auto',
                                                overflowY: topTestDetails.length > 2 ? 'auto' : 'visible',
                                            }}
                                        >
                                            {sortedTests.map((test, idx) => (
                                                <div
                                                    key={idx}
                                                    className="d-flex justify-content-between align-items-center border-bottom py-2"
                                                >
                                                    <div className="flex-grow-1">
                                                        <div className="fw-semibold">{test.TestName}</div>
                                                        <small className="text-muted">Count: {test.Count}</small>
                                                    </div>
                                                    <div className="text-end">
                                                        <span className="badge bg-light text-dark px-3 py-2">
                                                            {currencySymbols[userInfo?.Partner_Account_Details?.CurrencyIsoCode]}{test.Test_NetAmount}
                                                        </span>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                    // <div className="card border mb-2" style={{ fontSize: '12px' }}>
                                    //     <div className="card-header fw-bold py-2">Tests & Revenue Details</div>

                                    //     <div
                                    //         className="px-2"
                                    //         style={{
                                    //             maxHeight: topTestDetails.length > 2 ? '250px' : 'auto',
                                    //             overflowY: topTestDetails.length > 2 ? 'auto' : 'visible',
                                    //         }}
                                    //     >
                                    //         {topTestDetails.map((test, idx) => (
                                    //             <div
                                    //                 key={idx}
                                    //                 className="d-flex justify-content-between align-items-center border-bottom py-2"
                                    //             >
                                    //                 <div className="flex-grow-1">
                                    //                     <div className="fw-semibold">{test.TestName}</div>
                                    //                     <small className="text-muted">Count: {test.Count}</small>
                                    //                 </div>
                                    //                 <div className="text-end">
                                    //                     <span className="badge bg-light text-dark px-3 py-2">
                                    //                         {currencySymbols[userInfo?.Partner_Account_Details?.CurrencyIsoCode]}{test.Test_NetAmount}
                                    //                     </span>
                                    //                 </div>
                                    //             </div>
                                    //         ))}
                                    //     </div>
                                    // </div>

                                    // No Records Found
                                ) : (
                                    <div className="alert alert-warning p-2" style={{ fontSize: '12px' }}>
                                        No records found.
                                    </div>
                                )}
                            </div>
                        </div> */}



                        {/* <TopTestDetailsConponentPieChart
                            topTestDetails={topTestDetails}
                            testChartLoader={testChartLoader}
                        /> */}


                        {/* Service Console */}

                    </div>
                </>
            ) :
                // <div className="container-fluid p-2" style={{ backgroundColor: "#f5f5f5", minHeight: "125vh" }}>
                // <div className="container-fluid" style={{ backgroundColor: "#f5f5f5", minHeight: "120vh" }}>
                <div style={{marginLeft: "-12px", marginRight: "-12px"}}>
                <CommonContainer heading="Dashboard">
                    <div style={{borderBottom: "1px solid #ccc", marginBottom: "20px"}}></div>
                    {userRole === "Sales-Admin" ? (
                        <>
                            <SalesAdminDashboardComponent />
                        </>
                    ) : (
                        <>
                            <div className="rounded p-3 mb-3" style={{ backgroundColor: "#e4f4e0" }}>
                                <div className="d-flex flex-column flex-sm-row gap-2 justify-content-sm-between align-items-center">
                                    <div>
                                        <small>WELCOME TO METROPOLIS</small>
                                        {/* <h4 className="fw-bold">Power your Revenue Opportunity</h4> */}
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                    </CommonContainer>
                </div>
            }

            {
                selectedNotification &&
                notificationModalStatus && (
                    <NotificationPopUpComponent NotificationDet={selectedNotification} handleModalClose={handleModalClose} />
                )
            }
        </div >

    );
}

export default DashboardComponent;
